import { withStyles } from '@material-ui/core'
import Button from '@material-ui/core/Button'

export const DataCellButton = withStyles({
  label: { textTransform: 'none', fontWeight: 200, textAlign: 'left', justifyContent: 'left' , minHeight: 19},
})(Button)
